import React, { useEffect, useState } from "react";
import {
    getActiveEncryptionKey,
    getEncryptionKeys,
    rotateEncryptionKey,
} from "../../api/encryptionKeyService";

export default function EncryptionKeyPage() {
    const [activeKey, setActiveKey] = useState(null);
    const [keys, setKeys] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const loadData = async () => {
        try {
            setError("");
            const active = await getActiveEncryptionKey();
            const list = await getEncryptionKeys();

            setActiveKey(active);
            setKeys(Array.isArray(list) ? list : []);
        } catch {
            setError("Failed to load encryption keys.");
        }
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleRotate = async () => {
        if (!window.confirm("Rotate encryption key?")) return;

        try {
            setMessage("");
            setError("");

            const result = await rotateEncryptionKey();
            setMessage(result?.message || "Encryption key rotated.");
            await loadData();
        } catch {
            setError("Failed to rotate encryption key.");
        }
    };

    return (
        <div className="max-w-4xl mx-auto p-6 bg-white rounded shadow">
            <h1 className="text-xl font-bold mb-4">Encryption Key Management</h1>

            {error && <p className="text-red-600 mb-3">{error}</p>}
            {message && <p className="text-green-600 mb-3">{message}</p>}

            {activeKey && (
                <div className="border p-4 rounded mb-4">
                    <h2 className="font-semibold mb-2">Active Key</h2>
                    <p><b>ID:</b> {activeKey.id}</p>
                    <p><b>Created:</b> {activeKey.createdAt ? new Date(activeKey.createdAt).toLocaleString() : "�"}</p>
                    <p><b>Expires:</b> {activeKey.expiresAt ? new Date(activeKey.expiresAt).toLocaleString() : "�"}</p>
                </div>
            )}

            <button
                onClick={handleRotate}
                className="bg-red-600 text-white px-4 py-2 rounded mb-6"
            >
                Rotate Key
            </button>

            <h2 className="font-semibold mb-2">Key History</h2>

            <table className="w-full border text-sm">
                <thead>
                    <tr className="bg-gray-100">
                        <th className="border p-2">ID</th>
                        <th className="border p-2">Created</th>
                        <th className="border p-2">Expires</th>
                    </tr>
                </thead>
                <tbody>
                    {keys.map((key) => (
                        <tr key={key.id}>
                            <td className="border p-2">{key.id}</td>
                            <td className="border p-2">
                                {key.createdAt ? new Date(key.createdAt).toLocaleString() : "�"}
                            </td>
                            <td className="border p-2">
                                {key.expiresAt ? new Date(key.expiresAt).toLocaleString() : "�"}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}